const identityDocumentList = [
    {value: 'Passport', label: 'Passport'},
    {value: 'ID Card', label: 'ID Card'}
]

export {identityDocumentList}